import React from 'react';
import { styled, useStyletron } from 'baseui';
import { LabelSmall } from 'baseui/typography';
type Props = {
  header: string;
  content: string;
};
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: `${$theme.sizing.scale200} 0`,
  maxWidth: `calc(100% - ${$theme.sizing.scale900})`
}));
export const CardItem = ({
  header,
  content
}: Props) => {
  const [, theme] = useStyletron();
  return <Container>
      <LabelSmall color={theme.colors.contentTertiary} $style={{
      whiteSpace: 'pre'
    }}>
        {header + ' : '}
      </LabelSmall>
      <LabelSmall color={theme.colors.contentPrimary} $style={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }}>
        {content}
      </LabelSmall>
    </Container>;
};